module.exports = __webpack_public_path__ + "img/IdcardHold.60e9614f.png";